export enum ImageType {
    Basic = "Basic",
    Avatar = "Avatar",
    Rounded = "Rounded"
}